<template>
  <b-row v-if="$route.name === 'EXCMDeviceCreate'">
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXCMAgreementList' }" class="mb-1 btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMAgreementForm
                    :handle-submit="onSendForm"
                    :handle-update-field="updateField"
                    :values="item"
                    :errors="violations" />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col>
      <EXCMAgreementForm
        :openedInCreateModal="true"
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :values="item"
        :errors="violations" />
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMAgreementForm from './Form'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('excmagreement/create')

export default {
  props: {
    openedInModal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    EXCMAgreementForm,
    Loader
  },

  data () {
    return {
      item: {
        agreementDevices: [],
        agreementConsents: [],
        agreementSlas: [],
        agreementCyclicTasks: [],
        contactPerson: null,
        company: null
      }
    }
  },

  beforeCreate () {
    checkPagePermission('agreements', 'EXCMAgreementCreate')
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      if (!this.openedInModal) {
        this.$Swal({
          title: this.$t('notifications.created'),
          type: 'success',
          showConfirmButton: false,
          timer: 1500
        })
        this.$router.push({ name: 'EXCMAgreementList' })
      } else {
        this.$store.state.modals.excmagreement.create.close = 1
      }
    }
  },
  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      let item = Object.assign({}, this.item)
      if (item.dateFrom === '') {
        item.dateFrom = undefined
      } else {
        item.dateFrom = this.$moment(item.dateFrom).format('YYYY-MM-DD')
      }
      if (item.dateTo === '') {
        item.dateTo = undefined
      } else {
        item.dateTo = this.$moment(item.dateTo).format('YYYY-MM-DD')
      }
      for (let i in item.agreementConsents) {
        item.agreementConsents[i].agree = parseInt(item.agreementConsents[i].agree)
      }
      for (let i in item.agreementDevices) {
        item.agreementDevices[i].isDeviceAddressBasedOnAgreement = parseInt(item.agreementDevices[i].isDeviceAddressBasedOnAgreement)
      }
      for (let i in item.agreementCyclicTasks) {
        if (item.agreementCyclicTasks[i].dateFrom) {
          item.agreementCyclicTasks[i].dateFrom = this.$moment(item.agreementCyclicTasks[i].dateFrom).format('YYYY-MM-DD')
        }
        if (item.agreementCyclicTasks[i].dateTo) {
          item.agreementCyclicTasks[i].dateTo = this.$moment(item.agreementCyclicTasks[i].dateTo).format('YYYY-MM-DD')
        }
        if (item.agreementCyclicTasks[i].daysInterval) {
          item.agreementCyclicTasks[i].daysInterval = parseInt(item.agreementCyclicTasks[i].daysInterval)
        }
      }
      this.create(item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
